import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore, collection, getDocs, getDoc, addDoc, deleteDoc, doc, onSnapshot, serverTimestamp, orderBy, query, updateDoc
} from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAoEPoRFLXJi0IuLHC6AHRZiwxE82jcKwQ",
  authDomain: "sdf-training.firebaseapp.com",
  projectId: "sdf-training",
  storageBucket: "sdf-training.appspot.com",
  messagingSenderId: "928658681594",
  appId: "1:928658681594:web:a31e7f2d3058037563a343"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

//init services
const db = getFirestore()
const auth = getAuth()

//collection ref
const colRefSdf1 = collection(db, 'sdf1')
const colRefSdf3 = collection(db, 'sdf3')

//query
const queryOrderedSdf1 = query(colRefSdf1, orderBy('createdAt'))
const queryOrderedSdf3 = query(colRefSdf3, orderBy('createdAt'))
//get collection data


export {
  db, colRefSdf1, addDoc, deleteDoc, doc, getDocs, onSnapshot,serverTimestamp, orderBy, queryOrderedSdf1, updateDoc, collection, query, auth
}
createApp(App).use(router).mount('#app')
